var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGridArrowForward = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 24,
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m12.035 4-1.41 1.41 5.58 5.59H4.035v2h12.17l-5.58 5.59 1.41 1.41 8-8-8-8Z",
  fill: "#000",
  fillOpacity: 0.56
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgGridArrowForward);
export { ForwardRef as ReactComponent };